import { __decorate, __extends } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import AddEditCopyLogistics from '../components/addEditCopyLogistics/index.vue';

var AddLogisticsAgentPage = function (_super) {
  __extends(AddLogisticsAgentPage, _super);

  function AddLogisticsAgentPage() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  AddLogisticsAgentPage = __decorate([Component({
    components: {
      AddEditCopyLogistics: AddEditCopyLogistics
    }
  })], AddLogisticsAgentPage);
  return AddLogisticsAgentPage;
}(Vue);

export default AddLogisticsAgentPage;